import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Leadership icon
 *
 * @category Business
 */
const Leadership = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          stroke="currentColor"
          stroke-width=".1"
          d="M16.241 10.458c4.883-.248 5.108-7.921-.2-8.052-5.333-.059-5.285 8.064-.024 8.064h.224zm-.023-6.893c3.24.166 3.547 5.261.224 5.651-4.102.52-4.315-5.615-.413-5.65h.2z"
        />
        <path
          fill="currentColor"
          stroke="currentColor"
          stroke-width=".1"
          d="M16.218 12.976c2.34.07 4.599 1.667 5.426 3.925.154.674 1.1 2.447 1.372.804-.769-7.744-12.887-7.838-14.01-.284-.083 1.43.816 1.112 1.135.095.745-2.577 3.145-4.587 5.864-4.552h.213zm7.909 7.176c-1.17.071-2.282.591-3.121 1.42-.591.626-1.088.614-1.679-.013-1.726-1.82-4.918-1.809-6.633 0-1.134 1.324-1.856-.485-3.002-.934-2.85-1.478-6.645.816-6.68 4.02-.26 3.582 3.866 6.172 6.916 4.35.863-.425 1.632-1.915 2.59-.945 1.844 2.104 5.308 1.95 7.105-.13.567-.473.981-.107 1.525.402 2.73 2.707 7.507.71 7.815-2.932.366-2.672-2.022-5.297-4.658-5.238h-.19zM7.41 28.346c-2.057-.083-3.63-2.389-3.039-4.375.828-3.062 5.214-3.37 6.515-.544 1.123 2.27-.804 5.167-3.334 4.93H7.41zm8.264.047c-3.89-.166-4.22-6.574-.26-7 5.202-.709 5.391 7.177.402 7.012h-.154zm8.276 0c-3.89-.166-4.22-6.574-.26-7 5.202-.709 5.39 7.177.402 7.012h-.154z"
        />
      </svg>
    );
  }
);

Leadership.displayName = 'Leadership';

export { Leadership };
